// zipStore.js — minimal store-only (no compression) zip writer for client-side bundling of a
// few generated files (pitch PNG export). JS twin of supabase/functions/_shared/app_assembler/
// zip.ts: same fixed timestamp, same layout, so archives are deterministic here too.

const FIXED_DOS_TIME = 0;
const FIXED_DOS_DATE = (46 << 9) | (1 << 5) | 1; // 2026-01-01

const CRC_TABLE = (() => {
  const t = new Uint32Array(256);
  for (let n = 0; n < 256; n += 1) {
    let c = n;
    for (let k = 0; k < 8; k += 1) c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
    t[n] = c >>> 0;
  }
  return t;
})();

function crc32(data) {
  let c = 0xffffffff;
  for (let i = 0; i < data.length; i += 1) c = CRC_TABLE[(c ^ data[i]) & 0xff] ^ (c >>> 8);
  return (c ^ 0xffffffff) >>> 0;
}

function u16(v) { return [v & 0xff, (v >>> 8) & 0xff]; }
function u32(v) { return [v & 0xff, (v >>> 8) & 0xff, (v >>> 16) & 0xff, (v >>> 24) & 0xff]; }

/** entries: [{ name: string, data: Uint8Array }] -> zip archive Blob. */
export function buildZipBlob(entries) {
  const enc = new TextEncoder();
  const parts = [];
  const central = [];
  let offset = 0;

  for (const { name, data } of entries) {
    const nameBytes = enc.encode(name);
    const crc = crc32(data);
    const header = new Uint8Array([
      0x50, 0x4b, 0x03, 0x04,
      ...u16(20), ...u16(0x0800), ...u16(0),
      ...u16(FIXED_DOS_TIME), ...u16(FIXED_DOS_DATE),
      ...u32(crc), ...u32(data.length), ...u32(data.length),
      ...u16(nameBytes.length), ...u16(0),
    ]);
    parts.push(header, nameBytes, data);
    central.push({ nameBytes, crc, size: data.length, offset });
    offset += header.length + nameBytes.length + data.length;
  }

  const centralParts = [];
  let centralSize = 0;
  for (const e of central) {
    const rec = new Uint8Array([
      0x50, 0x4b, 0x01, 0x02,
      ...u16(20), ...u16(20), ...u16(0x0800), ...u16(0),
      ...u16(FIXED_DOS_TIME), ...u16(FIXED_DOS_DATE),
      ...u32(e.crc), ...u32(e.size), ...u32(e.size),
      ...u16(e.nameBytes.length), ...u16(0), ...u16(0), ...u16(0), ...u16(0),
      ...u32(0), ...u32(e.offset),
    ]);
    centralParts.push(rec, e.nameBytes);
    centralSize += rec.length + e.nameBytes.length;
  }
  const end = new Uint8Array([
    0x50, 0x4b, 0x05, 0x06,
    ...u16(0), ...u16(0), ...u16(central.length), ...u16(central.length),
    ...u32(centralSize), ...u32(offset), ...u16(0),
  ]);
  return new Blob([...parts, ...centralParts, end], { type: 'application/zip' });
}
